import { Product } from 'src/types/common';

type FilterParams = {
  products: Product[];
  categoriesInReview: string[];
};

export default function filterProductsInReview({
  products,
  categoriesInReview,
}: FilterParams): Product[] {
  const slugsToExclude = categoriesInReview.map((s) => s.toLowerCase());

  return products.filter((product) => {
    const categories = product.product._categories || [];
    const tags = product.product._tags || [];

    const hasMatchingCategory = categories.some((category) =>
      slugsToExclude.includes(category.toLowerCase())
    );
    const hasMatchingTag = tags.some((tag) =>
      slugsToExclude.includes(tag.toLowerCase())
    );

    return !hasMatchingCategory && !hasMatchingTag;
  });
}
